<template>
	<div style="background-color:#fffcf7;" class="container">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="1"
		@click="(e) => { val.page = (e+2); $emit('next_page', THIS.val); }"
		:click_fnc="$localStorage.get('user').username.role==3"
		/>
		<div
			class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-3 border-15 shadow bg-white text-center"
			data-aos="flip-up"
			data-aos-easing="ease-out-cubic"
			data-aos-duration="2000"
			style="
			display: flex;
			align-items: center;
			justify-content: center;
			align-content: center;
			"
		>
			<div style="width: 75%; max-width: 500px;">
				<textInput
					:val="val.value.fullname"
					:disabled="true"
					:valid="1"
					label="نام و نام خانوادگی"
					
				/>
				<textInput
					:val="val.value.sex == 1 ? 'مرد' : 'زن' "
					:disabled="true"
					:valid="1"
					label="جنسیت"
					/>
					<textInput
					:val="val.value.fatherName"
					:disabled="true"
					label="نام پدر"
					:valid="1"
					/>
					<textInput
					:val="val.value.identityId"
					:disabled="true"
					label="شماره شناسنامه"
					:valid="1"
				/>
				<btn
					@clickMe="sav()"
					class="w-100 mt-3"
					textClass="w-100"
					text="مرحله بعد"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import textInput from  "../../UI/input/textInput.vue";
	import btn from  "../../UI/button/btn.vue";
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	
	export default {
			name: 'personalInformation_edit',
		data(){
			return {
				imgurl: window.imgurl,
				baseurl: window.baseurl,
			}
		},
		components: {
			btn,
			textInput,
			multi_step_progress,
		},
			props: ["val"],
		mounted(){
			this.$swal.close();
		},
		methods:{
			// *********************************************************************
			sav(THIS=this){
				THIS.val.page = 4;
				THIS.$emit('next_page', THIS.val);
			},
			// *********************************************************************
		}
	}
</script>

<style>
</style>
